/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The load state of the unit file.
 */
export enum SystemdLoadStateType {
  SystemdLoadStateStub = 'stub',
  SystemdLoadStateLoaded = 'loaded',
  SystemdLoadStateNotFound = 'not-found',
  SystemdLoadStateBadSetting = 'bad-setting',
  SystemdLoadStateError = 'error',
  SystemdLoadStateMerged = 'merged',
  SystemdLoadStateMasked = 'masked',
  SystemdLoadStateUnknown = 'unknown',
}
